var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app',[(_vm.loadingStatus)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-animation"},[_c('v-progress-linear',{attrs:{"color":"#1976d2","indeterminate":"","height":"6"}})],1)]):_vm._e(),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }